import styled from 'styled-components';
import { Steps } from 'antd';

export const StyledFormSectionWrapper = styled.section`
    border-radius: 6px;
    margin-bottom: 12px;
    padding: 16px 24px;
    max-width: 720px;
    border: 1px solid var(--gray-4);
    background-color: var(--gray-1);
`;

export const StyledSteps = styled(Steps)`
    .ant-steps-item:hover {
        .ant-steps-item-icon {
            border-color: var(--gray-10) !important;
        }
        .ant-steps-item-title {
            color: currentColor !important;
        }
    }

    .ant-steps-item-icon > .ant-steps-icon {
        color: var(--gray-9);
    }

    .ant-steps-item-icon {
        background-color: var(--success-normal);
        color: var(--gray-1);
        border-color: transparent;
        user-select: none;
    }

    .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
        background-color: var(--gray-1);
        border-color: transparent;
    }

    .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
        background-color: var(--success-normal);
    }

    /* Complete step */
    .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after {
        background-color: var(--gray-4);
    }

    /* Current step */
    .ant-steps-item-process.ant-steps-item-active {
        .ant-steps-item-icon {
            background-color: var(--brand-6);
        }
    }

    /* Inactive step */
    .ant-steps-item-wait {
        .ant-steps-item-icon {
            background-color: var(--gray-5);
        }
    }

    .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
        color: var(--gray-9);
        user-select: none;
    }

    .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title {
        color: var(--secondary-text);
    }

    .ant-steps-item-wait {
        .ant-steps-item-icon {
            background-color: var(--gray-4);
            border-color: var(--border-color);
        }
    }

    .ant-steps-finish-icon {
        color: var(--gray-1);
    }

    .optional-step {
        &.ant-steps-item-wait .ant-steps-item-icon,
        &.ant-steps-item-process:not(.ant-steps-item-active) .ant-steps-item-icon {
            background-color: var(--gray-1);
            border-color: var(--border-color);
            color: var(--gray-7);
        }

        &.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
            color: var(--gray-7);
        }
    }

    .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
        color: var(--secondary-text);
    }

    &.ant-steps-vertical {
        .ant-steps-item {
            margin-bottom: 32px;
        }

        .ant-steps-item-tail {
            top: 6px !important;
            width: 2px !important;

            &::after {
                height: 20px !important;
                width: 2px !important;
            }
        }
    }
`;
